import { filter, mapTo } from 'rxjs/operators';
import {
    incrementLoadingCounter,
    decrementLoadingCounter
} from '../actions/loading-actions';

const startLoadingEpic = action$ =>
    action$.pipe(
        filter((a: any) => a.type.includes('REQUEST')),
        mapTo(incrementLoadingCounter())
    );

const stopLoadingEpic = action$ =>
    action$.pipe(
        filter((a: any) =>
            ['RECEIVE', 'FETCH_ERROR'].some(s => a.type.includes(s))
        ),
        mapTo(decrementLoadingCounter())
    );

export default [startLoadingEpic, stopLoadingEpic];
